import { graphql } from 'gatsby';
import { PageTitle } from 'hem-ui';
import React from 'react';

import { root } from './RichTextPageTitle.module.scss';

const RichTextPageTitle: React.FC<{
  node: { data: { target: Queries.RichTextPageTitleFragment } };
}> = ({ node }) => {
  const entry = node.data.target;

  if (!entry) {
    console.warn('[RichTextPageTitle] Entry not rendered', { node });
    return null;
  }

  return (
    <div className={root}>
      <PageTitle
        topTitle={entry.topTitle}
        title={entry.title}
        subtitle={entry.sub?.childMarkdownRemark.html}
        description={entry.desc?.childMarkdownRemark.html}
      />
    </div>
  );
};

export default RichTextPageTitle;

export const query = graphql`
  fragment RichTextPageTitle on ContentfulComponentPageTitle {
    __typename
    contentful_id
    topTitle
    title
    sub: subtitle {
      childMarkdownRemark {
        html
      }
    }
    desc: description {
      childMarkdownRemark {
        html
      }
    }
  }
`;
